import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';

import Section, {
  SectionHeader, SectionTitle, SectionBody, SectionBodyEmptyContent,
} from 'components/common/Section';
import IconHouse from 'components/icons/IconHouse';
import ReferralSourceCreateEditDialog from 'components/settings/ReferralSourceCreateEditDialog';
import SortableList from 'components/common/SortableList';

import { changePatientResource } from 'redux/modules/patients';

import ReferralSourceItem from './ReferralSourceItem';
import ReferralSourceAddForm from './ReferralSourceAddForm';


const styles = theme => ({
  iconHouse: {
    width: 18,
    height: 16,
  },
  form: {
    width: '65%',
  },
  desktopOnly: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
});

class ReferralSource extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dialogOpen: false,
      loading: false,
    };

    this.onCreateButtonClick = this.onCreateButtonClick.bind(this);
    this.onDialogClose = this.onDialogClose.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onCreateButtonClick() {
    this.setState({ dialogOpen: true });
  }

  onDialogClose() {
    this.setState({ dialogOpen: false });
  }

  onChange(referralSource) {
    const { patient, actions } = this.props;
    this.setState({ loading: true });
    actions.changePatientResource({
      'Record Number': patient['Record Number'],
      'Referral Source': referralSource,
      resolve: () => {
        this.setState({ loading: false });
      },
      reject: () => {
        this.setState({ loading: false });
      },
    });
  }

  render() {
    const { patient, classes } = this.props;
    const { loading } = this.state;
    return (
      <Section>
        <SectionHeader>
          <SectionTitle>
            Referral <span className={classes.desktopOnly}>Source</span>
          </SectionTitle>
          <ReferralSourceAddForm
            className={classes.form}
            onCreateButtonClick={this.onCreateButtonClick}
            disabled={!patient}
            variant="default"
            onSubmitSuccess={(values) => {
              this.onChange([
                { id: values.ID },
                ...patient['Referral Source'].map(item => ({ id: item.ID })),
              ]);
            }}
            referralSource={patient['Referral Source']}
          />
        </SectionHeader>
        <SectionBody padding="none">
          {(!patient || patient['Referral Source'].length === 0) ? (
            <SectionBodyEmptyContent
              text="There are no referral sources yet"
              icon={(
                <IconHouse className={classes.iconHouse} />
              )}
            />
          ) : (
            <SortableList
              id="sortableListReferralSource"
              items={patient['Referral Source']}
              itemComponent={ReferralSourceItem}
              dragDisabled={loading}
              onSortingChange={(values) => {
                this.onChange(values.sortedItems.map(item => ({id: item.ID })));
              }}
              onSetPrimaryContact={(value) => {
                this.onChange(patient['Referral Source'].map(item => ({ 
                  id: item.ID,
                  ...value.id === item.ID ? { referral_source_contact_id: value.referral_source_contact_id } : {},
                })));
              }}
            />
          )}
          <ReferralSourceCreateEditDialog
            form="referralSourceCreate"
            open={this.state.dialogOpen}
            onClose={this.onDialogClose}
            onSubmitSuccess={(values) => {
              this.onChange([
                { id: values.ID },
                ...patient['Referral Source'].map(item => ({ id: item.ID })),
              ]);
            }}
          />
        </SectionBody>
      </Section>
    );
  }
}

ReferralSource.propTypes = {
  patient: PropTypes.shape({
    'Record Number': PropTypes.number,
    'Referral Source': PropTypes.arrayOf(PropTypes.shape({
      ID: PropTypes.number,
    })),
  }),
  actions: PropTypes.shape({
    changePatientResource: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    form: PropTypes.string.isRequired,
    iconHouse: PropTypes.string.isRequired,
  }).isRequired,
};

ReferralSource.defaultProps = {
  patient: null,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ changePatientResource }, dispatch),
});

export default connect(null, mapDispatchToProps)(
  withStyles(styles)(ReferralSource),
);



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/ReferralSource/ReferralSource.js